export class Administrator {
  _id?: string;
  name: string = '';
  email: string = '';
  password?: string;
  role: number = 2;
  active: boolean = false;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/shared/administrator.model.ts